<template>
  <div id="industryDynamics"> 
    <Navigation/>
    <div class="container-fluid container_fluid">
      <div class="row fluid_row">
       <div v-if="slientWidth > 750"> 
        <div class="col-md-3 left_Column"> 
          <div class="col-md-6 left_cont" v-for="(target,id) in leftList" :key="id" @click="choseprofrom(id)" :class="{'secectBackground':flag==id}">{{target.name}}</div>
        </div>
       </div> 

       <div v-if="slientWidth < 750"> 
        <div class="col-md-3 left_Column"> 
          <!-- <div class="col-md-6 left_cont" v-for="(target,id) in leftList" :key="id" @click="choseprofrom(id)" :class="{'secectBackground':flag==id}">{{target.name}}</div> -->
          <!-- <div class="col-md-6 left_cont" v-for="(target,id) in leftList" :key="id" @click="choseprofrom(id)" :class="{'secectBackground':flag==id}">{{target.name}}</div> -->
        </div>
       </div> 

        <div class="col-md-8 right_Content">
          <!-- 公司简介 -->
          <div class="col-md-12 right_Modular">
            <div class="col-md-12" id="ModularCon">
              <div class="right_border"></div>
              <div class="right_cont_title">{{titles?'公司动态':'公司简介'}}</div>
              <div class="right_cont_slogan">{{titIntroduction?'密切关注业界新闻动态':'让中医药健康服务，插上智能化翅膀'}}</div>
            </div>
            <!-- 行业动态新闻 -->
            <div class="col-md-9 Dynamic_News" v-if="slientWidth > 750">
                <div class="col-md-5 Dynamic_News_content" v-for="(value,key) in dynamicList" :key="key" @click="seeDynamiDetails(value.id)">
                    <span class="News_content_title">{{value.title}}</span>
                    <img :src="value.thumb" class="News_content_img">
                    <p class="News_content_cont">{{value.description}}</p>
                </div>
                <span class="loadBtn" id="load_btn" @click="loadDataBtn" >{{hideBottom?'加载更多':'已加载完'}}</span>
            
            </div>

            <div class="col-md-8 Dynamic_News" v-if="slientWidth < 750">
              <div class="col-md-5 Dynamic_News_content" v-for="(value,key) in dynamicList" :key="key" @click="seeDynamiDetails(value.id)">
                  <span class="News_content_title">{{value.title}}</span>
                  <img :src="value.thumb" class="News_content_img">
                  <p class="News_content_cont">{{value.description}}</p>
              </div>

              <span class="loadAppBtn"  @click="appLoadDataBtn" >{{appHideBottom?'点击加载':'已加载全部内容'}}</span>
            </div>
            
          </div>

        </div>

      </div>
    </div>
    <ReturnTop/>
    <HeadTail/>
  </div>
</template>

<script>
import navigation from './publicComponent/Navigation'
import headTail from './publicComponent/HeadTail'
import returnTop from './publicComponent/ReturnTop'
export default {
  data(){
    return{
      leftList:[
        // {name:"行业动态",id:1,},
        {name:"公司动态",id:2,},
      ],
      flag: -1,
      // newImages:[
      //   {imagS:'../../static/image/homeImage/webNew2.png'},
      // ]
      imagS:'../../static/image/homeImage/webNew2.png',
      slientWidth:document.body.clientWidth,
      dynamicList:[],
      dynamicList1:[],
      pageNo:1, //当前页码
      pageSize: 6, //每页加载条数
      pagetotal: 0, //一共要请求的次数
      hideBottom: true,
      titles:true,
      titIntroduction:true,
      id: 1,
      appHideBottom:true
    }
  },
  created(){
    this.flag = 0
    if(document.body.clientWidth > 750){
      this.CompanyTop = '../../static/image/CompanyProfileImage/contentImage.png'
      this.CompanyIdea = '../../static/image/CompanyProfileImage/webIdea.png'
    }else{
      this.CompanyTop = '../../static/image/CompanyProfileImage/appContentImage.png'
      this.CompanyIdea = '../../static/image/CompanyProfileImage/appIdea.png'
      
    }
    this.getList()
  },
  mounted(){
    if(document.body.clientWidth < 750){
      document.getElementById("ModularCon").style.display = "none"
    }
  },
  methods:{
      choseprofrom:function (id) {
        this.flag = id;
        if(id == 1){
          this.titles = false,
          this.titIntroduction = false
        }else{
          this.titles = true,
          this.titIntroduction = true
        }
        if(id){
          this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{size:6,cid: 17}}).then(res =>{
            this.dynamicList = res.data.data
          })
        }else{
          this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{size:6,cid: 17}}).then(res =>{
            this.dynamicList = res.data.data
          })
        }

      },
      getList(){
        if(document.body.clientWidth > 750){
          this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{size:6,cid: 17}}).then(res =>{
            this.dynamicList = res.data.data
          })
        }else{
          this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{size:6,cid: 17}}).then(res =>{
            this.dynamicList = res.data.data
          })
        }  
      },
      loadDataBtn(){
        if(document.body.clientWidth > 750){
          if(this.hideBottom){
            if(this.flag){
                this.pageNo ++;
                let pageNo = this.pageNo
                this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{page:this.pageNo,size:6,cid: 17}}).then(res =>{
                  let dynamicList = this.dynamicList.concat(res.data.data)
                  if(res.data.status_code ===1 && res.data.data.length >= 1){
                    this.dynamicList = dynamicList
                    pageNo = this.pageNo + 1
                    
                  }
                  if(this.dynamicList.length == res.data.meta.count){
                        this.hideBottom = false
                    }else{
                      this.hideBottom = true
                    }
                })
            }else{
                this.pageNo ++;
                let pageNo = this.pageNo
                this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{page:this.pageNo,size:6,cid: 17}}).then(res =>{
                  let dynamicList = this.dynamicList.concat(res.data.data)
                  if(res.data.status_code ===1 && res.data.data.length >= 1){
                    this.dynamicList = dynamicList
                    pageNo = this.pageNo + 1
                    
                  }
                  if(this.dynamicList.length == res.data.meta.count){
                        this.hideBottom = false
                    }else{
                      this.hideBottom = true
                    }
                })
            }
            
          }
        }  
      },
      
      appLoadDataBtn(){
          if(document.body.clientWidth < 750){
            if(this.flag){
                this.pageNo ++;
                let pageNo = this.pageNo
                this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{page:this.pageNo,size:6,cid: 17}}).then(res =>{
                  let dynamicList = this.dynamicList.concat(res.data.data)
                  // if(res.data.status_code ===1 && res.data.data.length === 6){
                  //   this.dynamicList = dynamicList
                  //   pageNo = this.pageNo + 1
                  // }else if(this.dynamicList.length == res.data.meta.count){
                  //   this.appHideBottom = false
                  //   console.log(this.appHideBottom,"false")
                  // }else{
                  //   this.appHideBottom = true
                  //     console.log(this.appHideBottom ,"true")
                  // }
                  if(res.data.status_code ===1 && res.data.data.length >= 1){
                    this.dynamicList = dynamicList
                    pageNo = this.pageNo + 1
                  }else{
                    this.appHideBottom = false
                    console.log(this.dynamicList)
                    return
                  }

                })
            }else{
                this.pageNo ++;
                let pageNo = this.pageNo
                this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{page:this.pageNo,size:6,cid: 17}}).then(res =>{
                  let dynamicList = this.dynamicList.concat(res.data.data)
                  if(res.data.status_code ===1 && res.data.data.length >= 1){
                    this.dynamicList = dynamicList
                    pageNo = this.pageNo + 1
                  }else{
                    this.appHideBottom = false
                    return
                  }
                  // if(this.dynamicList.length == res.data.meta.count){
                  //   this.appHideBottom = false
                  // }else{
                  //   this.appHideBottom = true
                  // }
                })
            }

        }  
        // this.pageNo ++;
        // let pageNo = this.pageNo
        // this.$http.get("https://api.hanfangyiyang.cn/cms/articles",{params:{page:this.pageNo,size:6,cid: 2}}).then(res =>{
        //   let dynamicList = this.dynamicList.concat(res.data.data)
        //   if(res.data.status_code ===1 && res.data.data.length >= 1){
        //     this.dynamicList = dynamicList
        //     pageNo = this.pageNo + 1
        //   }else{
        //     this.appHideBottom = false
        //     return
        //   }
        // })
      },
      seeDynamiDetails(aid){
        this.$router.push({  //核心语句
            path:'/Detailstest',   //跳转的路径
            query:{           //路由传参时push和query搭配使用 ，作用时传递参数
                aid:aid, 
            }
        })
      },
  },
  components: {
    'HeadTail': headTail,  //将别名demo 变成 组件 Demo
    "Navigation":navigation,
    "ReturnTop" : returnTop
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 750px){
    .fluid_row{
      margin-top: 11vh !important;
    }
    /* 左侧 */
    .left_Column{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-left: 6% !important;
    }
    .left_cont{
      padding-left: 24% !important;
      height: 2vw !important;
      line-height: 2vw;
      border-top: 1px solid #f1f1f1; 
      border-bottom: 1px solid #f1f1f1; 
      cursor:pointer;
      font-size: 13pt;
    }
    .secectBackground{
      border-right: 2px solid #0047ab;
      color: #0047ab;
    }
    /* 右侧 */
    /* 模块 */
    .right_Modular{
        margin-bottom: 15% !important;
    }
    .right_border{
      width: 12vw;
      height: 8vw;
      position: absolute;
      border: 10px solid #ebeced;
      left: 6%;
      top: 18%;
      z-index: -1;
    }
    .right_cont_title{
      font-size: 3vw;
      color: #0047ab;
      padding-left: 2% !important;
      padding-top: 3% !important;
      font-weight: 600;
    }
    .right_cont_slogan{
      font-size: 1.5vw;
      font-weight: 600;
      padding-left: 2% !important;
    }
    .Dynamic_News{
      /* border: 1px solid; */
      margin-top: 5% !important;
      /* height: 15vw ; */
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .Dynamic_News_content{
      /* border: 1px solid rebeccapurple; */
      margin-left: 2% !important;
      margin-bottom: 6% !important;
      display: flex;
      flex-wrap: nowrap;
      flex-direction: column;
      align-items: center;
    }
    .News_content_title{
      display: block;
      font-size: 0.8vw;
      font-weight: 600;
      margin-bottom: 1% !important;
    }
    .News_content_img{
      width: 100%;
      height: 40vh;
    }
    .News_content_cont{
      margin-top: 1% !important;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
    }
    .loadBtn{
      position: absolute;
      width: 90px;
      height: 33px;
      border: 1px solid #e3e2e3;
      bottom: 0 !important;
      left: 46% !important;
      line-height: 33px;
      text-align: center;
      border-radius: 8px;
      cursor:pointer;
    }
    

}

/* 移动端特殊样式 */
@media screen and (max-width: 750px){
    .container-fluid{
      margin-top: 12% !important;
    }
    .cont_image{
      width: 100%;
    }
    .cont_imageIdea{
      width: 100%;
    }
    .left_Column{
      display: flex;
      justify-content: center;
    }
    .left_cont{
      background: #f6f6f6;
      color: #666666;
      width: 48%;
      height: 6vh;
      text-align: center;
      line-height: 6vh;
      
    }
    .secectBackground{
      color: #fff;
      background: #00a5f6;
    }
    .left_cont:nth-child(1){
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    .left_cont:nth-child(2){
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .Dynamic_News{
      /* border: 1px solid; */
      margin-top: 5% !important;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .Dynamic_News_content{
      margin-left: 2% !important;
      margin-right: 2% !important;
      margin-bottom: 8% !important;
      display: flex;
      flex-wrap: nowrap;
      flex-direction: column;
      align-items: center;
    }
    .News_content_title{
      display: block;
      font-size: 4vw;
      font-weight: 600;
      margin-bottom: 1% !important;
    }
    .News_content_img{
      width: 100%;
    }
    .News_content_cont{
      margin-top: 1% !important;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
    }
    .loadAppBtn{
      width: 100%;
      border-top: 1px solid #f1f1f1;
      text-align: center;
      height: 5vh;
      line-height: 5vh;
    }

}

</style>



// WEBPACK FOOTER //
// src/components/IndustryDynamics.vue